/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var o;!function(o){o[o.Color=0]="Color",o[o.ColorNoRasterImage=1]="ColorNoRasterImage",o[o.Highlight=2]="Highlight",o[o.WaterNormal=3]="WaterNormal",o[o.Occluded=4]="Occluded",o[o.ObjectAndLayerIdColor=5]="ObjectAndLayerIdColor"}(o||(o={}));export{o as OverlayContent};
